module.exports = __webpack_public_path__ + "static/media/technology-get-to-the-bottom.96dc9822.webp";